<script setup>
// Injected into the agent-preview page as a ViewModule (only present when the BgBlur module is
// registered). Just binds the preview opt-in flag; AgentPreview.vue watches it and re-acquires.
import { useDeviceState } from "@/stores/deviceState";

const deviceState = useDeviceState();
</script>

<template>
  <v-checkbox v-model="deviceState.previewBackgroundEnabled" :label="$t('EnableBackground')" hide-details></v-checkbox>
</template>
